import { t } from "../../i18n/translations";

import styles from "./styles.module.scss";

export type ResultVariant = "passed" | "rejected" | "warning";

interface ResultMessageProps {
  variant: ResultVariant;
  messageKey: string;
}

function getVariantStyle(variant: ResultVariant) {
  if (variant === "passed") {
    return styles.passed;
  }
  if (variant === "warning") {
    return styles.warning;
  }
  return styles.rejected;
}

function ResultIcon({ variant }: { variant: ResultVariant }) {
  if (variant === "passed") {
    return (
      <svg className={styles.icon} viewBox="0 0 64 64" aria-hidden="true">
        <path d="M16 34l11 11 21-21" />
      </svg>
    );
  }

  if (variant === "warning") {
    return (
      <svg className={styles.icon} viewBox="0 0 64 64" aria-hidden="true">
        <path d="M32 8v28" />
        <circle
          cx="32"
          cy="50"
          r="5"
          fill="#ffffff"
          stroke="none"
          className={styles.exclamationDot}
        />
      </svg>
    );
  }

  return (
    <svg className={styles.icon} viewBox="0 0 64 64" aria-hidden="true">
      <path d="M18 18l28 28M46 18L18 46" />
    </svg>
  );
}

export function ResultMessage({ variant, messageKey }: ResultMessageProps) {
  return (
    <div className={styles.root}>
      <div className={`${styles.circle} ${getVariantStyle(variant)}`}>
        <ResultIcon variant={variant} />
      </div>
      <div className={styles.message}>{t(messageKey)}</div>
    </div>
  );
}
